import { render, staticRenderFns } from "./FullfilmentTolerancesPage.vue?vue&type=template&id=a8abe406&scoped=true&"
import script from "./FullfilmentTolerancesPage.vue?vue&type=script&lang=ts&"
export * from "./FullfilmentTolerancesPage.vue?vue&type=script&lang=ts&"
import style0 from "./FullfilmentTolerancesPage.vue?vue&type=style&index=0&id=a8abe406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8abe406",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VDivider,VRow,VSheet})
